<template>
  <div class="test-container">
    <div class="app-module-operation mb8 mt15">
      <div class="flex" style="justify-content: space-between">
        <div>&nbsp;</div>
        <div class="flex">
          <div>
            <el-button class="mr5" type="info" plain size="small" @click="reloadData">
              <i class="el-icon-refresh" />
              <span>刷新</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-table :key="tableKey" ref="multipleTable" v-loading="listLoading" :data="list" :height="tableHeight"
        tooltip-effect="dark" style="width: 100%">
        <!-- <el-table-column :show-overflow-tooltip="true" type="selection" width="30" /> -->
        <el-table-column :show-overflow-tooltip="true" fixed label="UA-id" resizable width="70" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="UA详情" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.uaMessage }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="处理状态" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <a v-if="scope.row.uaStatus=='1'" href="javascript:;">
              <i class="config-tag config-tag-success" />已处理
            </a>
            <a v-if="scope.row.uaStatus=='0'" href="javascript:;">
              <i class="config-tag config-tag-disabled" />未处理
            </a>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="匹配类型" width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.parserType }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" fixed="right" class-name="status-col" label="操作" width="80" align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="edit-content">
              <a href="javascript:;" @click="handleCurrentRow(scope.row)">发布</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt10">
        <el-pagination :current-page="pageInfo.currentPage" :page-sizes="pageInfo.pageSizeList"
          :page-size="pageInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageInfo.allCount"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
    <el-dialog :title="'UA-id:'+tableRowId" :close-on-click-modal="false" :visible.sync="dialogVisibleFilter"
      height="auto">
      <ListFilter :key="new Date().getTime()" type="advertCodeLoading" :table-row-id="tableRowId"
        @closeModle="handleClose" @returnResult="receiveData" @refresh="reloadData" />
    </el-dialog>
    <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="dialogVisiblePrompt" width="400px" />
  </div>
</template>

<script>
  import {
    getUaList
  } from '../..//api/uaedit.js'
  import ListFilter from '@/components/EntryJSConfigManage/ListFilter'
  import {
    setLocalStorage,
    getLocalStorage,
    removeLocalStorage
  } from '../..//utils'

  export default {
    name: 'TemplateList',
    components: {
      ListFilter
    },
    filters: {
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'gray',
          deleted: 'danger'
        }
        return statusMap[status]
      }
    },
    data() {
      return {
        tableRowId: '001',
        tableKey: 0,
        pageInfo: {
          pageSize: 30,
          allCount: 0,
          currentPage: 1,
          currentPageCount: 0,
          pageSizeList: [30, 50, 100, 150, 200, 300]
        },
        dnsId: null,
        list: null,
        listLoading: true,
        currentPage4: 1,
        dialogVisible: false,
        radio: '1',
        input: '',
        paramArray: [{
          name: '',
          paramName: '',
          remark: ''
        }, {
          name: '',
          paramName: '',
          remark: ''
        }],
        multipleSelection: [],
        noResultHeight: document.body.clientHeight - 50 - 165 + 24,
        tableHeight: document.body.clientHeight - 50 - 165 + 24,
        tipType: null, // 提示框类型
        clickDialogModal: false,
        dialogVisibleFilter: false,
        dialogVisiblePrompt: false,
        parentData: {
          name: 1
        },
        showEdit: false, // 是否显示快捷编辑代码框
        jsEditorParams: {
          code: '',
          id: ''
        },
        name: 'adCode'
      }
    },
    mounted() {
      var _this = this
      window.onresize = function () {
        _this.tableHeight = document.body.clientHeight - 50 - 165 + 24
      }
      // 编辑成功或者编辑取消后列表页显示本地存储分页信息
      const operationLocalInfo = getLocalStorage(this.name + '_operation')
      const localPageInfo = getLocalStorage(this.name + '_pageInfo')
      if (operationLocalInfo && operationLocalInfo.type === 'edit') {
        this.pageInfo = localPageInfo
        // 清除本地存储
        removeLocalStorage(this.name + '_operation')
        removeLocalStorage(this.name + '_pageInfo')
        this.fetchData()
      } else {
        this.fetchData()
      }
    },
    methods: {
      handleClose() {
        this.dialogVisibleFilter = false
      },
      receiveData(event) { // 更多筛选组件回传数据
        if (event && event.name === 'cancel') { // 取消
          this.dialogVisibleFilter = false
        } else { // 提交
          this.dialogVisibleFilter = false
          this.pageIn.currentPage = 1
          this.fetchData()
        }
      },
      fetchData() {
        this.listLoading = true
        getUaList({
          page: this.pageInfo.currentPage,
          pageSize: this.pageInfo.pageSize
        }).then(results => {
          this.listLoading = false
          this.list = results.data.items
          this.pageInfo.allCount = results.data.total
        })
      },
      handleCurrentRow(row) { // 弹窗、获取当前行数据
        this.dialogVisibleFilter = true
        this.tableRowId = row.id
      },
      handleSizeChange(val) {
        this.pageInfo.pageSize = val
        this.pageInfo.currentPage = 1
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.pageInfo.currentPage = val
        this.fetchData()
      },
      reloadData() {
        this.fetchData()
      }
    }
  }

</script>
<style lang="scss" scoped>
  /deep/ .el-dialog__body {
    padding: 0px;
  }

  .test-container {
    padding: 0 20px;
    box-sizing: border-box;
  }

  .more-filter {
    display: block;
    float: left;
    height: 30px;
    padding: 0 10px;
    line-height: 30px;
    text-align: center;
    background: #eaf6fe;
  }

  .search-btn {
    font-weight: 600;
    display: block;
    float: right;
    height: 30px;
    width: 30px;
    line-height: 30px;
    text-align: center;
    background: #eaf6fe;
    font-size: 14px;
  }

  .edit-content {
    color: #108cee;
  }

  .app-module-operation {
    /*height: 30px;*/
    /*margin-top: 10px;*/
    /*margin-bottom: 8px;*/
    /*button{*/
    /*  height: 25px !important;*/
    /*  line-height: 25px;*/
    /*  font-size: 12px;*/
    /*  span{*/
    /*    margin-left: 0px;*/
    /*  }*/
    /*}*/
    /*.el-button{*/
    /*  padding: 0px 4px;*/
    /*}*/
  }

  .text-container {
    .text-item {
      display: flex;
      margin-bottom: 10px;

      label {
        line-height: 24px;
      }

      textarea {
        border: 1px solid #dcdfe6;
        height: 150px;
      }

      .param-content {
        /*display: flex;*/
        border: 1px solid #dcdfe6;
        background: #fbfbfb;
        padding: 8px 10px;

        .param-item {
          display: flex;
        }

        .operation-btn {
          color: red;
          font-size: 12px;
          line-height: 24px;
          margin-left: 15px;

          i {
            cursor: pointer;
          }
        }
      }
    }
  }

</style>
